import Extend from "flarum/common/extenders";
import Discussion from "flarum/common/models/Discussion";
import DiscussionView from "./models/DiscussionView";
export default [new Extend.Store().add("discussionview", DiscussionView), new Extend.Model(Discussion).attribute("canReset").attribute("viewCount").attribute("canViewNumber").hasMany("latestViews").hasMany("uniqueViews")];